/**
 * Configuration
 */

export default {
    name: 'likely',
    prefix: 'likely__',
};



// WEBPACK FOOTER //
// ./source/config.js